import { Paper } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Typography as Ty, Box } from "@mui/material";
import { useEffect, useState } from "react";
import axios from "axios";
import "./style.css";
import Fade from "react-reveal/Fade";
import clsx from "clsx";
import "./styles.scss";
import ReactHtmlParser from "react-html-parser";
import { useDispatch } from "react-redux";
import CustomTooltip from "../../../../common/Tooltip";
import { useNavigate } from "react-router-dom";

import {
  closeLoader,
  openLoader,
} from "../../../../store/loader/loaderReducer";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 480,
    [theme.breakpoints.down("sm")]: {
      minHeight: "unset",
    },
  },
  bannerItems: {
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    height: 450,
    width: "100vw",
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
    padding: "0 190px",
    [theme.breakpoints.down("md")]: {
      height: 400,
      backgroundPosition: "left",
      backgroundSize: "fill",
      padding: "0 8%",
    },
    [theme.breakpoints.down("sm")]: {
      height: "calc(0.45 * 100vw)",
      backgroundPosition: "left",
      backgroundSize: "fill",
      padding: "0 8%",
      minHeight: "350px",
    },
  },
  bannerFonts: {
    display: "flex",
    flexDirection: "column",
    // width: "515px",
  },
  bannerTitle3: {
    marginBottom: "5px",
  },
  bannerTitle2: {
    marginBottom: "5px",
  },
  white: {
    color: "white",
  },
  black: {
    color: "black",
  },
}));

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 0 },
    items: 1,
  },
  //   ,
  //   tablet: {
  //     breakpoint: { max: 1024, min: 464 },

  //     items: 2,
  //     slidesToSlide: 2 // optional, default to 1.

  //   },
  //   mobile: {
  //     breakpoint: { max: 464, min: 0 },
  //     items: 1,
  //     slidesToSlide: 1 // optional, default to 1.
  //   }
};

const HomepageBanner = () => {
  const classes = useStyles();
  const [data, setData] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(openLoader());
    axios({
      url: "https://citiis.niua.in/web/citiis/api/v1/homepage-banner",
      method: "get",
    })
      .then((res) => {
        setData(res.data?.data);
        dispatch(closeLoader());
      })
      .catch((err) => {
        console.log(err);
        dispatch(closeLoader());
      });
  }, []);

  return (
    <Paper className={clsx(classes.root, "homepagebannermaindiv")}>
      <Carousel
        swipeable={true}
        draggable={true}
        showDots={true}
        responsive={responsive}
        infinite={true}
        autoPlay={false}
        // autoPlay={false}
        autoPlaySpeed={4000}
        transitionDuration={1000}
        containerClass="carousel-container"
        removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}
        deviceType={"desktop"}
        dotListClass="dotClass"
        itemClass="carousel-item-padding-40-px"
      >
        {data?.list?.Bannersliders
          ? data?.list?.Bannersliders.map((item, index) => (
            <div key={index}>
              <Paper
                elevation={0}
                className={clsx(
                  classes.bannerItems,
                  // index === 5 ? "mobilebanneritemshomepageeventbanner" : "mobilebanneritemshomepage"
                  "mobilebanneritemshomepage"
                )}
                style={{
                  backgroundRepeat: index === 0 && "round",
                  backgroundPosition: index === 0 && "unset",
                }}
                sx={{ backgroundImage: `url(${item?.BannerImage})` }}
              >
                <Box
                  className={clsx(
                    // classes.bannerFonts,
                    // index === 0
                    //   ? "newbannerfont5"
                    //   : index === 1
                    //   ? "newbannerfont"
                    //   : index === 2
                    //   ? "newbannerfont1"
                    //   : index === 3
                    //   ? "newbannerfont2"
                    //   : index === 4
                    //   ? "newbannerfont3"
                    //   : index === 5
                    //   ? "newbannerfont4"
                    //   : ""

                    index === 0
                      ? "newbannerfont"
                      : index === 1
                        ? "newbannerfont1"
                        : index === 2
                          ? "newbannerfont2"
                          : index === 3
                            ? "newbannerfont3"
                            : index === 4
                              ? "newbannerfont4"
                              : index === 5
                                ? "newbannerfont4"
                                : ""
                  )}
                >
                  {/* {index === 0 ? (
                      <CustomTooltip title="Click to register for the event">
                        <button
                          className="btn btn-primary btnstyleourworkevent btnstyleourworkbtn3event"
                          onClick={() => {
                            navigate("/event/urbanclimatefilmfestival");
                          }}
                          // style={{ display: "none" }}
                        >
                          Register Now
                        </button>
                      </CustomTooltip>
                    ) : ( */}
                  <Fade left>
                    <Ty
                      variant="thinmedium3"
                      className={clsx(
                        classes.bannerTitle1,

                        item?.TextColour === "White"
                          ? classes.white
                          : classes.black
                      )}
                    >
                      {ReactHtmlParser(item?.BannerSubtitle)}
                    </Ty>
                    {/* {index === 3 && (
                        <CustomTooltip title="Click here to read more">
                          <button
                            className="btn btn-primary btnstyleourwork btnstyleourworkbtn3"
                            onClick={() => {
                              navigate("/ourwork");
                              // localStorage.setItem("frombtn", "nationallevel");
                            }}
                          >
                            Read More
                          </button>
                        </CustomTooltip>
                      )} */}
                    {/* <Ty variant="thinmedium" className={clsx(classes.bannerTitle1, item?.TextColour === 'White' ? classes.white : classes.black)}>
                  {item?.BannerTitle && item?.BannerTitle[0]}
                </Ty>
                <Ty variant="thicklarge" className={clsx(classes.bannerTitle2, item?.TextColour === 'White' ? classes.white : classes.black)}>
                  {item?.BannerTitle && item?.BannerTitle[1]}
                </Ty>
                <Ty variant="thinmedium" className={clsx(classes.bannerTitle3, item?.TextColour === 'White' ? classes.white : classes.black)}>
                  {item?.BannerTitle && item?.BannerTitle[2]}
                </Ty>
                <Ty variant="thickmedium" className={clsx(classes.bannerTitle4, item?.TextColour === 'White' ? classes.white : classes.black)}>
                  {item?.BannerTitle && item?.BannerTitle[3]}
                </Ty>
                <Ty variant="thinmedium" className={clsx(classes.bannerTitle4, item?.TextColour === 'White' ? classes.white : classes.black)}>
                  {item?.BannerTitle[4]}
                </Ty> */}
                  </Fade>
                  {/* )} */}
                  {/* <Fade left>
                      <Ty
                        variant="thinmedium3"
                        className={clsx(
                          classes.bannerTitle1,

                          item?.TextColour === "White"
                            ? classes.white
                            : classes.black
                        )}
                      >
                        {index === 5 ? (
                          <button
                            className="btn btn-primary btnstyleourwork btnstyleourworkbtn3"
                            onClick={() => {
                              navigate("/ourwork");
                              // localStorage.setItem("frombtn", "nationallevel");
                            }}
                          >
                            Read More
                          </button>
                        ) : (
                          ReactHtmlParser(item?.BannerSubtitle)
                        )}
                      </Ty>
                     
                    </Fade> */}
                </Box>
              </Paper>
            </div>
          ))
          : [1, 2, 3].map((item, index) => (
            <div className={classes.bannerItems} key={index}></div>
          ))}
      </Carousel>
    </Paper>
  );
};

export default HomepageBanner;
